import { handleActions } from 'redux-actions';
import { getParameterFromString } from '../../../../app/utils/getParameter';
import { shopifyActions } from '../../actions/shopifyCards';
export const { getShopifyCardById, getShopifyCardByIdSucceeded, getShopifyCardByIdFailed, getShopifyCards, getShopifyCardsSucceeded, getShopifyCardsFailed, getShopifyCard, testShopifyCard, testShopifyCardSucceeded, testShopifyCardFailed, editShopifyCard, editShopifyCardSucceeded, editShopifyCardFailed, removeShopifyCard, removeShopifyCardSucceeded, removeShopifyCardFailed, addShopifyCard, addShopifyCardSucceeded, addShopifyCardFailed, resetShopifyCard, } = shopifyActions;
export function emptyCard() {
    return {
        card_type: 'shopify',
        hook: {
            title: '',
            hook_id: '',
            api_key: '',
            password: '',
            shopifySubdomain: '',
            headers: null,
            uri_template: '',
            created_at: '',
            card_version: '',
        },
        template: '',
    };
}
function parseURLParameters(url) {
    return {
        api_key: getParameterFromString('api_key', url),
        password: getParameterFromString('password', url),
        shopifySubdomain: getParameterFromString('api_hostname', url),
    };
}
const initialState = {
    cards: [],
    currentCard: emptyCard(),
    testResult: null,
    meta: null,
};
// Reducer
export const shopifyCards = handleActions({
    [getShopifyCards.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'loading' }) });
    },
    [getShopifyCardsSucceeded.toString()]: (state, action) => {
        const cards = action.payload.data.custom_cards.filter((shopifyCard) => shopifyCard.card_type === 'shopify');
        cards.forEach((card) => {
            card.hook = Object.assign(Object.assign({}, card.hook), parseURLParameters(card.hook.uri_template));
        });
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'succeeded' }), cards });
    },
    [getShopifyCardsFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'failed' }) });
    },
    [getShopifyCard.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign({}, state.meta), currentCard: action.payload });
    },
    [getShopifyCardById.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'loading' }) });
    },
    [getShopifyCardByIdSucceeded.toString()]: (state, action) => {
        const card = action.payload.data;
        card.hook = Object.assign(Object.assign({}, card.hook), parseURLParameters(card.hook.uri_template));
        return Object.assign(Object.assign({}, state), { currentCard: action.payload.data, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'succeeded' }) });
    },
    [getShopifyCardByIdFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'failed' }) });
    },
    [testShopifyCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'loading' }), testResult: null });
    },
    [testShopifyCardSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'succeeded' }), testResult: Object.assign({}, action.payload.data) });
    },
    [testShopifyCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'failed' }) });
    },
    [addShopifyCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'loading' }) });
    },
    [addShopifyCardSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'succeeded' }) });
    },
    [addShopifyCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'failed' }) });
    },
    [removeShopifyCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'loading' }) });
    },
    [removeShopifyCardSucceeded.toString()]: (state, action) => {
        const cardsCopy = state.cards.slice();
        const cards = cardsCopy.filter((x) => x.hook_id !== action.payload.data.hook_id);
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'succeeded' }), currentCard: emptyCard(), cards: cards });
    },
    [removeShopifyCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'failed' }) });
    },
    [editShopifyCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'loading' }) });
    },
    [editShopifyCardSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'succeeded' }) });
    },
    [editShopifyCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'failed' }) });
    },
    [resetShopifyCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { currentCard: emptyCard(), testResult: null, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: null }) });
    },
}, initialState);
